import { TableConfigurationRequest } from "../../types/generated/api/TableConfigurationRequest"

export const TAG_VARIANTS = ["blue", "red", "yellow", "green", "purple", "orange", "gray", "pink"]

// Currently supported tables to have ordering functionality e2e
export const ORDERED_TABLES = Object.values(TableConfigurationRequest.table)
